import { Navigate, useLocation } from 'react-router-dom'
import { useIsAuthenticated } from '@/stores/auth'
import { ROUTES } from '@/config/routes'

interface PublicRouteProps {
  children: React.ReactNode
  redirectIfAuthenticated?: boolean
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ 
  children, 
  redirectIfAuthenticated = true 
}) => {
  const isAuthenticated = useIsAuthenticated()
  const location = useLocation()

  if (isAuthenticated && redirectIfAuthenticated) {
    // Redirect to dashboard if user is already authenticated
    const from = location.state?.from?.pathname || ROUTES.DASHBOARD
    return <Navigate to={from} replace />
  }

  return <>{children}</>
}